
import customerDomainService from "@/services/customerDomain.service";

export default {
    async showCustomer({ dispatch }, email) {
        return customerDomainService.showCustomer(email)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async searchCustomerLink({ dispatch }, data) {
        return customerDomainService.searchCustomerLink(data)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async updateCustomerDomain({ commit, dispatch }, data) {
        return customerDomainService.updateCustomerDomain(data)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
}